// extracted by mini-css-extract-plugin
export default {"userProfilePopup__popupContainer":"UserProfilePopup_userProfilePopup__popupContainer__OClT4"};